/**
 * Common drag and drop DataTransfer formats.
 *
 * https://web.dev/datatransfer/
 * https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types
 */var DragAndDropFormats;
(function (DragAndDropFormats) {
  DragAndDropFormats["TextHtml"] = 'text/html';
  DragAndDropFormats["TextPlain"] = 'text/plain';
  DragAndDropFormats["TextUriList"] = 'text/uri-list';
})(DragAndDropFormats || (DragAndDropFormats = {}));
export { DragAndDropFormats };